import { render, staticRenderFns } from "./EditTrade.vue?vue&type=template&id=3000ca8c&"
import script from "./EditTrade.vue?vue&type=script&lang=js&"
export * from "./EditTrade.vue?vue&type=script&lang=js&"
import style0 from "./EditTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3000ca8c')) {
      api.createRecord('3000ca8c', component.options)
    } else {
      api.reload('3000ca8c', component.options)
    }
    module.hot.accept("./EditTrade.vue?vue&type=template&id=3000ca8c&", function () {
      api.rerender('3000ca8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/program/EditTrade.vue"
export default component.exports